/**
 * @generated SignedSource<<11dc08c29354daa8f7d8e7e175133c52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ModelTryContentButtonVFolderFragment$data = {
  readonly host: string | null | undefined;
  readonly id: string;
  readonly name: string | null | undefined;
  readonly row_id: string | null | undefined;
  readonly " $fragmentType": "ModelTryContentButtonVFolderFragment";
};
export type ModelTryContentButtonVFolderFragment$key = {
  readonly " $data"?: ModelTryContentButtonVFolderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ModelTryContentButtonVFolderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ModelTryContentButtonVFolderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "row_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "host",
      "storageKey": null
    }
  ],
  "type": "VirtualFolderNode",
  "abstractKey": null
};

(node as any).hash = "0c82dfaf8db9ecea42fa474c3a8d16fa";

export default node;
